import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import { DateFormat } from "web_myplann/Shared/Utils/dateFormats";
import { optionalDateAsString } from "web_myplann/Shared/Validation/optionalDateAsString";
import { optionalPositiveInteger } from "web_myplann/Shared/Validation/optionalPositiveInteger";
import { ValidationLimits } from "web_myplann/Shared/Validation/validationLimits";

export const getManualValueShape = (t: TranslateFunction) => {
	const positiveNumberMessages = {
		positiveMessage: t(
			Resources.Portfolio.AddShared.Validations.positiveNumber,
		),
		maxMessage: t(Resources.Portfolio.AddShared.Validations.maxValue),
	};

	return {
		value: optionalPositiveInteger(
			ValidationLimits.Amount.Max,
			positiveNumberMessages,
		),
		invested: optionalPositiveInteger(
			ValidationLimits.Amount.Max,
			positiveNumberMessages,
		),
		valueDate: optionalDateAsString(
			DateFormat.Iso,
			t(Resources.Portfolio.AddShared.Validations.dateInFuture),
		),
	};
};
